import ChevronDown from '@heroicons/react/24/solid/ChevronDownIcon';
import SlidersHorizontal from './icons/slider-horizontal';

export type FilterHeaderPropsType = {
  isOpen: boolean;
  toggleOpen: () => void;
  activeCount: number;
};

function FilterHeader({ isOpen, toggleOpen, activeCount }: FilterHeaderPropsType) {
  const showActiveBadge = !isOpen && activeCount > 0;
  const showAllBadge = !isOpen && activeCount === 0;

  return (
    <button
      type='button'
      onClick={toggleOpen}
      aria-expanded={isOpen}
      aria-label='باز و بستن پنل فیلترها'
      className='group flex w-full cursor-pointer select-none items-center
       justify-between p-4 transition-colors hover:bg-amber-100/50'
    >
      <div className='flex items-center gap-3 text-gray-700'>
        <div
          className={`
            rounded-lg p-2 transition-all duration-200
            ${isOpen ? 'bg-amber-100 text-amber-600 shadow-sm' : 'bg-zinc-100 text-zinc-400'}
          `}
        >
          <SlidersHorizontal size={18} strokeWidth={2} />
        </div>
        <span className='text-sm font-bold text-gray-800'>پنل فیلترها</span>
      </div>

      <div className='flex items-center gap-3'>
        {showActiveBadge && (
          <span
            className='rounded-md bg-amber-200 px-2 py-1
             text-[10px] font-bold text-amber-700 shadow-sm'
          >
            {activeCount} فیلتر فعال
          </span>
        )}
        {showAllBadge && (
          <span
            className='rounded-md bg-gray-100 px-2 py-1 text-[10px]
             font-bold text-gray-500 shadow-sm'
          >
            همه
          </span>
        )}
        <ChevronDown
          width={18}
          height={18}
          className={`text-gray-400 transition-transform duration-300 ${
            isOpen ? 'rotate-180 text-amber-500' : ''
          }`}
        />
      </div>
    </button>
  );
}

export default FilterHeader;
